// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-header_layout__5qbfR","headline":"page-header_headline__y0sWe","hero":"page-header_hero__HokGI"};